import React, {useEffect, useState} from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import {Button, Card, Col, Divider, Form, Input, Menu, Popconfirm, Row, Space} from "antd";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import * as api from "../../apis/documents";
import {useRequest} from "ahooks";
import useAntTable from "../../utils/useAntTable";
import WithAuth from "../../utils/withAuth";
import ModifyModal from "./modifyModal";
import useFormModal from "../../utils/useFormModal";
import * as utils from "../../utils/utils";
import * as qiniu from "../../utils/qiniu";
import Moment from "moment";

const AddButton = WithAuth('add', Button)
const DeletePopconfirm = WithAuth('delete', Popconfirm)

function Documents() {

    const [form] = Form.useForm()
    const [queryParams, setQueryParams] = useState<any>({title: undefined, classification: 'all'})

    const {modalProps, setVisible} = useFormModal({
        onRequest: addDocument,
        onOk: () => {
            refresh()
            setVisible(false)
        }
    })

    const {data: classifications = []} = useRequest(api.getAllDocumentsClassifications, {
        formatResult: res => res.data.data,
    })

    const {tableProps, refresh} = useAntTable(api.getDocuments, {
        extraParams: {
            ...queryParams,
            classification: queryParams.classification === 'all' ? null : queryParams.classification
        }
    })

    async function addDocument(data: any) {
        const file = data.path.file
        const path = `pricebook/documents/${utils.generateFileName('document', file.name)}`
        await qiniu.upload(file, path)
        data.path = path
        return api.addDocument(data)
    }

    const {run: onDelete} = useRequest(api.deleteDocument, {
        manual: true,
        onSuccess: () => refresh()
    })

    useEffect(() => {
        refresh()
    }, [queryParams]);

    const columns: StandardColumnsType = [
        {
            dataIndex: 'title',
            title: 'Title',
            render: (data, record: any) => <a target='_blank' href={qiniu.getUrl(record.path)}>{data}</a>
        },
        {
            dataIndex: 'classification',
            title: 'Classification',
        },
        {
            dataIndex: 'createName',
            title: 'Create by',
        },
        {
            dataIndex: 'createTime',
            title: 'Create time',
            render: (value) => Moment(value).format('lll'),
        },
        {
            dataIndex: 'operations',
            title: 'Operations',
            render: (_, record: any) => (
                <span>
                    <DeletePopconfirm title={'Are you sure?'} onConfirm={() => onDelete(record.id)}>
                        <a>Delete</a>
                    </DeletePopconfirm>
                </span>
            )
        }
    ]

    return (
        <PageHeaderLayout>
            <Card>
                <Form labelCol={{span: 8}}
                      wrapperCol={{span: 16}}
                      form={form}
                      onFinish={values => setQueryParams({...queryParams, ...values})}
                >
                    <Row style={{width: '100%'}}>
                        <Col span={6} className={'SearchBar-Col LastRow'}>
                            <Form.Item name={'title'} label={'Title'}>
                                <Input/>
                            </Form.Item>
                        </Col>
                        <Col offset={11} span={6} style={{textAlign: "right"}} className={'SearchBar-Col LastRow'}>
                            <Space>
                                <Button onClick={() => form.resetFields()}>Reset</Button>
                                <Button type={'primary'} onClick={() => form.submit()}>Search</Button>
                            </Space>
                        </Col>
                    </Row>
                </Form>
            </Card>
            <div style={{display: 'flex', marginTop: 15}}>
                <div style={{marginRight: 15}}>
                    <AddButton style={{marginBottom: 15}} block type={'primary'} onClick={() => setVisible(true)}>Release
                        Documents</AddButton>
                    <Card style={{width: 300}}>
                        <Menu selectedKeys={[queryParams.classification]}
                              onSelect={item => setQueryParams({...queryParams, classification: item.key})}>
                            <Menu.Item key={'all'}>All</Menu.Item>
                            {classifications.map((item: any) => (
                                <Menu.Item key={item.id}>{item.name}</Menu.Item>
                            ))}
                        </Menu>
                    </Card>
                </div>
                <div style={{flex: 1}}>
                    <StandardTable rowKey={'id'} columns={columns} {...tableProps} />
                </div>
            </div>
            <ModifyModal {...modalProps}/>
        </PageHeaderLayout>
    )
}

export default Documents;
